import { render, staticRenderFns } from "./InspeccionElementosExtintor.vue?vue&type=template&id=40077b0a"
import script from "./InspeccionElementosExtintor.vue?vue&type=script&lang=js"
export * from "./InspeccionElementosExtintor.vue?vue&type=script&lang=js"
import style0 from "./InspeccionElementosExtintor.vue?vue&type=style&index=0&id=40077b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports